import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import InputGenerico from '../../components/inputGenerico/inputGenerico';
import { postRedefinirSenha } from '../../services/apiUsuario';
import { ToastContainer, toast } from 'react-toastify';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { erroToastify, sucessoToastify } from '../../shared/validacaoToastify';
import './redefinirSenha.css'

interface dadosRecuperacao {
    token: string,
    password: string,
    confirmPassword: string
}

export default function RedefinirSenha() {
    const [validacaoAtiva, setValidacaoAtiva] = useState<any>(false);
    const [senha, setSenha] = useState<string>("");
    const [senhaConfirm, setSenhaConfirm] = useState<string>("");



    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token') ?? '';
    const navigate = useNavigate();

    const handleSenha = (e: any) => {
        setSenha(e.target.value)
    }

    const handleSenhaConfirm = (e: any) => {
        setSenhaConfirm(e.target.value)
    }

    const resetarSenha = async (e: any) => {
        e.preventDefault();
        if (senha !== senhaConfirm) {
            toast.error('As senhas digitadas não coincidem.');
            return;
        }

        const dados: dadosRecuperacao = {
            token: token,
            password: senha,
            confirmPassword: senhaConfirm
        };

        try {
            if (token) {
                const responseData = await postRedefinirSenha(dados);
                sucessoToastify(responseData.data);

                setTimeout(() => {
                    navigate('/milshop/login');
                }, 3000);
            } else {
                erroToastify('Link quebrado ou expirado');
            }

        } catch (error: any) {
            if (error.response.data) {
                erroToastify(error.response.data);
            }
        }
    }

    return (
        <>
            <section style={{ display: 'grid', justifyContent: 'center' }}>
                <div className="mt-5">
                    <h1 className="text-center mt-3 " style={{ fontSize: '25px' }}>Recuperar Senha</h1>
                </div>

                <div className="rounded bg-light shadow" style={{ padding: '30px' }} >
                    <form className="mb-3">
                        <div className="containerIcon">
                            <FontAwesomeIcon icon={faKey} className="icon" />
                            <InputGenerico
                                name="Senha"
                                value={senha}
                                onChange={handleSenha}
                                placeholder=""
                                className={`${!(senha.length > 2) && validacaoAtiva ? "input-invalid" : ""} input-with-padding inputSenhaRedefinirSenha`}
                                type="password"
                            />

                        </div>
                        <div className="containerIcon">
                            <FontAwesomeIcon icon={faKey} className="icon" />
                            <InputGenerico
                                name="Senha"
                                value={senhaConfirm}
                                onChange={handleSenhaConfirm}
                                placeholder=""
                                className={`${!(senha.length > 2) && validacaoAtiva ? "input-invalid" : ""} input-with-padding inputSenhaRedefinirSenha`}
                                type="password"
                            />
                        </div>
                        <div className="containerBotoes mt-2">
                            <button className="botoesLogin btn btn-outline-primary btn-sm mt-3" type="submit" onClick={(e) => resetarSenha(e)}>Enviar</button>
                        </div>
                    </form>
                </div>
            </section>
            <ToastContainer />
        </>
    )
}
